// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { missingTimeZonePlaceholders } from "@sequentech/ui-core";
/**
 * Why the Localization tabs refuse an override, if they do: a combined
 * timezone string (`timezones.dateTimeZone`, `myTime`, `placeTime`,
 * `voterDateTimeZone`, `onThisDevice`, `gap`, `overlap`) must keep
 * `{{dateTime}}` and its zone placeholder in every scope.
 */
export var timeZoneTextOverrideError = function (t, key, value) {
    var missing = missingTimeZonePlaceholders(key, value);
    if (missing.length === 0) {
        return undefined;
    }
    return String(t("electionEventScreen.localization.notify.invalidTimeZoneText", {
        placeholders: missing.map(function (name) { return "{{".concat(name, "}}"); }).join(", "),
        interpolation: { escapeValue: false },
    }));
};
